/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface ClauseMetierSearch
 */
export interface ClauseMetierSearch {
    /**
     * 
     * @type {number}
     * @memberof ClauseMetierSearch
     */
    idclause?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClauseMetierSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ClauseMetierSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ClauseMetierSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ClauseMetierSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ClauseMetierSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ClauseMetierSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ClauseMetierSearch interface.
 */
export function instanceOfClauseMetierSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ClauseMetierSearchFromJSON(json: any): ClauseMetierSearch {
    return ClauseMetierSearchFromJSONTyped(json, false);
}

export function ClauseMetierSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClauseMetierSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idclause': !exists(json, 'idclause') ? undefined : json['idclause'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ClauseMetierSearchToJSON(value?: ClauseMetierSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idclause': value.idclause,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

